/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocArrowOutIcon24Solid = forwardRef('DocArrowOutIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 2h4.05v5.3a2.75 2.75 0 0 0 2.75 2.75H20v2.2c-.775 0-1.544.326-2.088.96a2.742 2.742 0 0 0-.65 2.04H16A6.75 6.75 0 0 0 9.25 22H8a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Z" }),
        React.createElement("path", { d: "M20 8.51v.04h-5.2c-.69 0-1.25-.56-1.25-1.25V2.06L20 8.51Z" }),
        React.createElement("path", { d: "M16.5 19a3.5 3.5 0 0 0-3.5 3.5v.5a1 1 0 1 1-2 0v-.5a5.5 5.5 0 0 1 5.5-5.5h4.297l-1.448-1.24a1 1 0 0 1 1.302-1.52l2.614 2.242a2 2 0 0 1 0 3.037l-2.614 2.24a1 1 0 0 1-1.302-1.518L20.797 19H16.5Z" })));
});
